type PhoebeRunEventsBusyState = {
    readonly currentRunStatus: 'running' | 'completed' | 'errored' | null;
    readonly isAwaitingRunCompletion: boolean;
    readonly isAgentThinking: boolean;
    readonly hasRunCompletionSignal: boolean;
};

export function shouldPollPhoebeRunEvents({
    currentRunStatus,
    isAwaitingRunCompletion,
    isAgentThinking,
    hasRunCompletionSignal,
}: PhoebeRunEventsBusyState): boolean {
    return (
        isAwaitingRunCompletion ||
        currentRunStatus === 'running' ||
        (isAgentThinking && !hasRunCompletionSignal)
    );
}
